export default __webpack_public_path__ + "static/media/r9.69c4657c.jpg";